module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nLUSiG/tc-custom/9780879466497_cover.jpg",
      "alt": "This image is the cover for the book Pistaco"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pistaco\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Steven McMahon, a young American struggling to reconcile his priestly vocation with his very human desire for love and intimacy, flees to Peru on mission, seeking the serenity he cannot find at home. In a tiny village in the Andes Mountains he meets a young school teacher chased by demons of her own. They soon find themselves trapped between the brutal Shining Path guerrillas who threaten mayhem across the mountain countryside and a harsh military counter-insurgency trying to quash the rebellion. Amid this historic struggle between the forces of order and ungodly acts of terror, and haunted by the legend of el pistaco, a mythical fiend believed by locals to feed on the unwary, they discover the meaning—and the price—of love.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynn F. Monahan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("LYNN F. MONAHAN is a writer and editor who has written for newspapers, newswires, and magazines. He has traveled widely, especially in Latin America, and lived in Peru during much of the 1990s, an experience that inspired Pistaco. Currently a US-based journalist, Monahan has written award-winning stories from four continents about people who live on the margins of what we dub “civilization.” A Connecticut native, he graduated from Syracuse University and holds a master’s degree in writing from Manhattanville College. He and his wife have two daughters and live in Westchester County, New York.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    In Exstenso Press\n   ")]), _vm._v(" "), _c('a', {
    staticClass: "publisherURL body link",
    attrs: {
      "href": "http://www.inextensopress.com/",
      "target": "_blank"
    }
  }, [_vm._v("\n\n        About Publisher\n   ")]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4cb4cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0